import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import {withRouter} from "react-router";

class AdvertConfirmationModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired,
        children: PropTypes.node.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {children, ...props} = this.props;
        return (
            <Modal {...props} className="modal-alert modal-success" bsSize="small">
                <Modal.Header>
                    <i className="fa fa-check"/>
                </Modal.Header>
                <Modal.Body>
                    <h5>Поздравляем!</h5>
                    {children}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-success"
                            onClick={() => this.redirect()}>
                        ОК
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    redirect() {
        this.props.history.push('/');
    }
}

export default withRouter(AdvertConfirmationModal);


// WEBPACK FOOTER //
// ./src/pages/Adverts/CreateAdvert/modals/AdvertConfirmationModal.js